import { Component, OnInit, Input } from '@angular/core';
import { FormsService } from '../services/form.service';
import { FormAnswer } from '../Dto/FormAnswer';
import { Form } from '../Dto/Form';
import { FormGroup, FormControl } from '@angular/forms';
import { Question } from '../Dto/Question';
import { DynamicFormElement } from '../Dto/DynamicFormElement';
import { FormElement } from '../Dto/FormElement';
import { Consent } from '../Dto/Consent';
import { Label } from '../Dto/Label';
import { QuestionChoice } from '../Dto/QuestionChoice';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reapply',
  templateUrl: './reapply.component.html',
  styleUrls: ['./reapply.component.css'],
  providers: [FormsService]
})
export class ReapplyComponent implements OnInit {

  guid: string;

  formAnswer: FormAnswer;
  formGroup: FormGroup;
  form: Form;
  email: string;
  consent: Consent;
  state = 'emailForm';
  sections: Array<{ Section: DynamicFormElement[], name: string }> = new Array<{ Section: DynamicFormElement[], name: string }>();
  allQuestions: DynamicFormElement[] = new Array<DynamicFormElement>();

  constructor(
    private route: ActivatedRoute,
    private formsService: FormsService
  ) { }

  ngOnInit() {
    this.guid = this.route.snapshot.paramMap.get('guid');
  }

  public getFormAnswer() {
    this.state = 'consentAcceptance';
    this.formsService.getMissingConsent(this.guid, this.email).subscribe(
      consent => this.consent = consent,
      err => {
        if (this.state == 'consentAcceptance')
          this.state = 'unknownError'
      }
    );
    this.formsService.authorizeFormAnswer(this.guid, this.email).subscribe(data => {
      this.formAnswer = data;
    },
      error => {
        if (error.status == 404) this.state = 'notFound';
        else if (error.status == 400) this.state = 'badRequest';
        else if (error.status == 401) this.state = 'unauthorized';
        else this.state = 'unknownError';
      },
      () => {
        if (this.state == 'consentAcceptance')
          this.getForm();
      });
  }

  private getForm() {

    this.form = this.formAnswer.form;
    for (let i = 0; i < this.form.sections.length; i++) {
      var formElements = this.form.sections[i].formElements;

      if (formElements.length > 0) {
        let sect = this.toFormElement(formElements, this.form.sections[i].formId);
        let nam = this.form.sections[i].name;
        this.sections.push({ Section: sect, name: nam });
      }
    }
    this.formGroup = new FormGroup(this.prepare(this.form));
    for (let i = 0; i < this.formAnswer.fileAnswers.length; i++) {
      let type = this.formAnswer.fileAnswers[i].contentType;
      let name = this.formAnswer.fileAnswers[i].fileName;
      let id = this.formAnswer.fileAnswers[i].fileAnswerId;
    }

  }

  public addConsent() {
    this.state = 'loading';
    this.formsService.addConsent(this.guid, this.email).subscribe(
      _ => {
        this.state = 'consentConfirmed';
      },
      error => {
        if (error.status == 404) this.state = 'notFound';
        else if (error.status == 400) this.state = 'badRequest';
        else if (error.status == 401) this.state = 'unauthorized';
        else this.state = 'unknownError';
      });
  }

  private prepare(form: Form): any {
    let dataObject = this.toDynamicFormElelement(form);
    let objectProps =
      Object.keys(dataObject)
        .map(prop => {
          return Object.assign({}, { key: prop }, dataObject[prop]);
        });

    const formGroup = {};
    for (let prop of Object.keys(dataObject)) {
      if (dataObject[prop])
        formGroup[prop] = new FormControl(dataObject[prop].value);
    }

    return formGroup;
  }

  private toFormElement(elements: FormElement[], formId: number): DynamicFormElement[] {
    let dynamics = new Array<DynamicFormElement>();
    for (let i = 0; i < elements.length; i++) {
      let newDynamic = new DynamicFormElement();
      if (elements[i].type == "Question") {
        newDynamic.key = 'q' + ((<Question>elements[i]).questionId == 0 ? elements[i].id : (<Question>elements[i]).questionId);
        newDynamic.label = (<Question>elements[i]).questionText;
        newDynamic.type = this.toType(<Question>elements[i]);
        if (newDynamic.type == 'text') {
          var cnt = (<Question>elements[i]).rowCount;
          newDynamic.rowCount = cnt;
        }
        if ((<Question>elements[i]).questionChoices != null && (<Question>elements[i]).questionChoices.length > 0) {
          var ansIndx = this.formAnswer.questionAnswers.indexOf(this.formAnswer.questionAnswers.find(x => x.questionId == (<Question>elements[i]).questionId));
          let ans = this.formAnswer.questionAnswers[ansIndx];
          newDynamic.options = this.toOptions((<Question>elements[i]).questionChoices, ans != null ? ans.answer : '');
          if (ans != null) {
            this.formAnswer.questionAnswers.splice(ansIndx, 1);
          }
        }
        else if (newDynamic.type == 'datetodate') {
          newDynamic.key = 'q' + ((<Question>elements[i]).questionId == 0 ? elements[i].id : (<Question>elements[i]).questionId) + "a";
          var ansIndx = this.formAnswer.questionAnswers.indexOf(this.formAnswer.questionAnswers.find(x => x.questionId == (<Question>elements[i]).questionId));
          let answers = this.formAnswer.questionAnswers[ansIndx];
          if (answers) {
            let date = answers.answer.split(' do ');
            if (date) {
              newDynamic.value = date[0];
            }
          }

          if (dynamics.find(x => x.key == newDynamic.key) || this.sections.find(x => x.Section.find(s => s.key == newDynamic.key) != null))
            newDynamic.key = newDynamic.key + formId;
          dynamics.push(newDynamic);
          newDynamic = new DynamicFormElement();
          newDynamic.type = this.toType(<Question>elements[i]);
          if (answers) {
            let date = answers.answer.split(' do ');
            if (date) {

              newDynamic.value = date[1];
            }
          }
          if (answers != null) {
            this.formAnswer.questionAnswers.splice(ansIndx, 1);
          }
          newDynamic.key = 'q' + ((<Question>elements[i]).questionId == 0 ? elements[i].id : (<Question>elements[i]).questionId) + "b";
        }
        else if (newDynamic.type == 'date') {
          var ansIndx = this.formAnswer.questionAnswers.indexOf(this.formAnswer.questionAnswers.find(x => x.questionId == (<Question>elements[i]).questionId));
          let answers = this.formAnswer.questionAnswers[ansIndx];
          if (answers) {
            newDynamic.value = answers.answer;
          }

          if (answers != null) {
            this.formAnswer.questionAnswers.splice(ansIndx, 1);
          }
        }
        else if (newDynamic.type != 'file') {
          var ansIndx = this.formAnswer.questionAnswers.indexOf(this.formAnswer.questionAnswers.find(x => x.questionId == (<Question>elements[i]).questionId));
          let ans = this.formAnswer.questionAnswers[ansIndx];
          if (ans)
            newDynamic.value = ans.answer;
          if (ans != null) {
            this.formAnswer.questionAnswers.splice(ansIndx, 1);
          }
        }
      }
      else if (elements[i].type == "Label") {
        newDynamic.key = 'l' + ((<Label>elements[i]).labelId == 0 ? elements[i].id : (<Label>elements[i]).labelId);
        newDynamic.label = (<Label>elements[i]).text;
        newDynamic.type = '';

      } else {
        newDynamic.key = 'c' + ((<Consent>elements[i]).consentId == 0 ? elements[i].id : (<Consent>elements[i]).consentId);
        var consentIndx = this.formAnswer.consentAnswers.indexOf(this.formAnswer.consentAnswers.find(x => x.consentId == (<Consent>elements[i]).consentId));
        var consent = this.formAnswer.consentAnswers[consentIndx];
        newDynamic.options.push({ label: (<Consent>elements[i]).text, key: "o" + (<Consent>elements[i]).consentId, check: consent != null ? true : false });
        if (consent != null)
          this.formAnswer.consentAnswers.splice(consentIndx, 1);
        newDynamic.type = 'checkbox';
      }
      if (dynamics.find(x => x.key == newDynamic.key) || this.sections.find(x => x.Section.find(s => s.key == newDynamic.key) != null))
        newDynamic.key = newDynamic.key + "." + formId;
      this.allQuestions.push(newDynamic);
      dynamics.push(newDynamic);
    }
    return dynamics;
  }

  getName(key: string): string {
    let id = key.replace('q', '');
    if (id.includes('.')) {
      var ids = id.split('.');
      return this.getName(ids[0]);
    } else {
      let ansInd = this.formAnswer.fileAnswers.indexOf(this.formAnswer.fileAnswers.find(x => x.questionId == Number(id)));
      let anse = this.formAnswer.fileAnswers[ansInd];
      let filename: string = '';
      if (anse) {
        filename = anse.fileName;
        this.formAnswer.fileAnswers == this.formAnswer.fileAnswers.filter(x => x.fileName != filename);
      }
      return filename;
    }
  }

  private toDynamicFormElelement(form: Form): Map<string, DynamicFormElement> {
    let dynamics = new Map<string, DynamicFormElement>();
    for (let i = 0; i < this.sections.length; i++) {
      for (let j = 0; j < this.sections[i].Section.length; j++) {
        if (dynamics[this.sections[i].Section[j].key] != undefined) {
          dynamics[this.sections[i].Section[j].key + form.formId] = this.sections[i].Section[j];
        } else
          dynamics[this.sections[i].Section[j].key] = this.sections[i].Section[j];
      }
    }
    return dynamics;
  }

  private toOptions(choices: QuestionChoice[], answer: string): { key: string, label: string, check: boolean }[] {

    let answers = answer.split(';');
    let options = new Array<{ key: string, label: string, check: boolean }>();
    let i = 0;
    choices.forEach(x => {
      options.push({ label: x.choice, key: "o" + i++, check: answers.find(z => z == x.choice) != null ? true : false });
    })
    return options;
  }

  private toType(question: Question): string {
    switch (question.questionType) {
      case 'onechoice': return 'radio';
      case 'salary':
        return question.questionChoices.length > 0 ? 'radio' : 'text';
      case 'multichoice': return 'checkbox';
      case 'list': return 'list';
      case 'file': return 'file';
      case 'date': return 'date';
      case 'datetodate': return 'datetodate';
      case 'email': return 'email';
      case 'phone': return 'tel';
      case 'open': return 'text';
      case 'nameSurname': return 'name';
      case 'name': return 'name';
      case 'surname': return 'name';
      case 'city': return 'city';
      default: return 'text';
    }
  }

  getDate(key: string): string {
    let id = key.replace('q', '');
    return this.formAnswer.questionAnswers
      .find(x => x.questionId == Number(id))
      ? this.formAnswer.questionAnswers.find(x => x.questionId == Number(id)).answer
      : '';
  }

  getDates(key: string): string {
    return this.formGroup.controls[key].value != null
      ? this.formGroup.controls[key].value.day + '-' + this.formGroup.controls[key].value.month + '-' + this.formGroup.controls[key].value.year
      : '';
  }
}
